<template>
  <div id="tac-admin-product-acq-disp-model" class="tac-admin product-acq-disp-model">
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-admin-product-acq-disp -->
</template>

<script>
import ApiResponseMixin from '@/plugin/mixin/api-response'
import AuthMixin from '@/plugin/mixin/auth'
import FormMixin from '@/plugin/mixin/form'

export default {
  mixins: [
    ApiResponseMixin,
    AuthMixin,
    FormMixin
  ]
}
</script>
